(function () {
    // Capture-phase delegation so taps fire before Dawn's MenuDrawer can swallow them.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-acc]');
      if (!btn) return;
      var nav = btn.closest('sm-drawer-nav');
      if (!nav) return;
      e.preventDefault(); e.stopPropagation();
      var acc = btn.closest('.sm-acc');
      var body = btn.nextElementSibling; // .sm-acc-body
      var open = acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) { if (open) { body.removeAttribute('hidden'); } else { body.setAttribute('hidden', ''); } }
    }, true);

    function setAcc(acc, open) {
      acc.classList.toggle('is-open', open);
      var b = acc.querySelector(':scope > .sm-acc-body');
      if (b) { if (open) b.removeAttribute('hidden'); else b.setAttribute('hidden', ''); }
      var s = acc.querySelector(':scope > .sm-acc-summary');
      if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // On open: auto-expand the first top-level category. On close: collapse everything.
    function bindReset() {
      var d = document.getElementById('Details-menu-drawer-container');
      if (!d || d.__smReset) return;
      d.__smReset = true;
      d.addEventListener('toggle', function () {
        if (!d.open) {
          d.querySelectorAll('.sm-acc.is-open').forEach(function (acc) { setAcc(acc, false); });
        } else {
          var first = d.querySelector('.sm-acc-list > .sm-acc-li > .sm-acc');
          if (first) setAcc(first, true);
        }
      });
    }
    if (document.readyState !== 'loading') bindReset(); else document.addEventListener('DOMContentLoaded', bindReset);
    document.addEventListener('shopify:section:load', bindReset);
  })();
